export function getId(val) {
	if (val == null) return null;
	if (typeof val !== "object") return val;
	return val.$oid ?? val.id ?? val._id ?? null;
}

export function round(n, p = 6) {
	return Math.round((n + Number.EPSILON) * 10 ** p) / 10 ** p;
}

export async function fetchOnce(cache, key, loader) {
	if (cache.has(key)) return cache.get(key);
	const val = await loader(key);
	cache.set(key, val);
	return val;
}
